import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useGetGreenerUnits } from 'hooks/useGetGreenerUnits';
import { orderBy } from 'lodash';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const baseGreenerUnitFilter = {
  filterKey: 'greener_unit__external_identifier__contains',
};

const createGreenerUnitFilter = (value) => ({
  ...baseGreenerUnitFilter,
  value,
});

export const GreenerAssetFilter = ({ updateFilters, clearFilter, getFilterValues }) => {
  const { t } = useTranslation();
  const { data: greenerUnits = [], isLoading, refetch } = useGetGreenerUnits({ queryConfig: { suspense: false } });

  const [filteredUnit] = getFilterValues?.(baseGreenerUnitFilter.filterKey) || '';

  const handleSelectionChange = (unit, reason) => {
    if (reason === 'clear' || reason === 'removeOption') {
      clearFilter(baseGreenerUnitFilter.filterKey);
    }

    if (!unit) {
      clearFilter(baseGreenerUnitFilter.filterKey);
    } else {
      const newValueFilter = createGreenerUnitFilter(unit.externalIdentifier);
      updateFilters([newValueFilter]);
    }
  };

  const sortedGreenerUnits = useMemo(() => {
    return orderBy(greenerUnits, ['name'], ['asc']);
  }, [greenerUnits]);

  const selectedUnit = sortedGreenerUnits.find((unit) => unit.externalIdentifier === filteredUnit) ?? null;

  return (
    <Autocomplete
      options={sortedGreenerUnits}
      getOptionLabel={(option) =>
        typeof option === 'string' ? option : `${option?.externalIdentifier} (${option?.name})`
      }
      loading={isLoading}
      onOpen={() => refetch()}
      loadingText={<CircularProgress size={15} />}
      value={selectedUnit}
      onChange={(_, value, reason) => handleSelectionChange(value, reason)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t('entities:greenerUnit.nameSingular')}
          placeholder={t('entities:greenerUnit.selectAsset')}
          size="small"
          InputLabelProps={{ shrink: true }}
        />
      )}
    />
  );
};
